var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('piepkaart',{attrs:{"minLoadDataZoom":0},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var bounds = ref.bounds;
var minLoadDataZoom = ref.minLoadDataZoom;
return [_c('piepkaart-json-layer',{attrs:{"bounds":bounds,"minLoadDataZoom":minLoadDataZoom,"data":_vm.data,"onEachFeature":_vm.onEachFeature,"styleOptions":_vm.styleOptions}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }